import axios from 'axios';

export const getWazzupIframe = contactId => axios.get('/messaging/wazzup/iframe/chats/', { params: { contactId } });

export const getWazzupAuthorizeUrl = () => axios.get('/messaging/wazzup/authorize/');

export const getWazzupChannels = () => axios.get('/messaging/wazzup/channels/');

export const sendWazzupMessage = payload => axios.post('/messaging/wazzup/messages/', payload);
